/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonERP, TableERP } from "@finanedi.es/storybook"
import { faSpinnerThird } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useQuery } from "@tanstack/react-query"
import {
  getResumenIvaImpuestos as getAsientoContableModelo303,
  getAsientoContableModelo390,
  postAsientoDeLiquidacion,
} from "api/AsientoContable.service"
import { PeriodoGetModelo303DtoProps } from "api/DTOs/PeriodoGetModelo303Dto"
import { PeriodoGetModelo390DtoProps } from "api/DTOs/PeriodoGetModelo390Dto"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { PERIODO } from "api/Types/Periodo"
import { TrimestreEnumType } from "api/Types/TrimestreEnum"
import { AxiosResponse } from "axios"
import Modal from "common/components/Modal/Modal"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import notification from "common/utils/notification"
import { extractFilename } from "common/utils/utils"
import ModalAsientoContable from "features/Contabilidad/components/ModalAsientoContable/ModalAsientoContable"
import { Dropdown } from "primereact/dropdown"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import {
  DECLARACION_MODELO_303,
  DECLARACION_MODELO_390,
} from "routes/RoutePaths"
import { HandleTabs } from "../../DetalleImpuestos"
import { MODELOS_IMPUESTOS } from "../../constants/modelosImpuestos"
import { RedirectParams } from "../constants"
import { IVA_IMPUESTOS_COLUMNS, obtenerFechaFinTrimestre } from "./constant"

const ResumenImpuestos = ({
  props: { year, handleYearSelection, yearsOptionList },
  isModel390 = false,
}: {
  props: HandleTabs
  isModel390?: boolean
}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const navigate = ({ route, periodo, tipo, modelo, year }: RedirectParams) => {
    history.push(route, {
      periodo,
      modelo,
      tipo,
      year,
    })
  }

  const { handleDirectDownloadExcel } = useDownloadFileContext()

  const [isLoadingConfirm, setIsLoadingConfirm] = useState<
    TrimestreEnumType | boolean
  >(false)

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["modelo303o390", year.selectedYear, isModel390],
    queryFn: () =>
      (isModel390 ? getAsientoContableModelo390 : getAsientoContableModelo303)({
        Anyo: year.selectedYear ?? new Date().getFullYear(),
        Periodo: PERIODO.TRIMESTRAL,
      }),
    select: (response) => {
      const periodos = response?.periodos ?? []
      return [
        ...(isModel390 ? [] : [...periodos]),
        {
          periodo: undefined,
          ...periodos.reduce((acc, curr) => ({
            asientoContableLiquidacionId: null,
            periodo: undefined,
            repercutido: {
              baseImponible:
                (acc.repercutido?.baseImponible ?? 0) +
                (curr.repercutido?.baseImponible ?? 0),
              iva: (acc.repercutido?.iva ?? 0) + (curr.repercutido?.iva ?? 0),
            },
            soportado: {
              baseImponible:
                (acc.soportado?.baseImponible ?? 0) +
                (curr.soportado?.baseImponible ?? 0),
              iva: (acc.soportado?.iva ?? 0) + (curr.soportado?.iva ?? 0),
            },
            totalIva: (acc.totalIva ?? 0) + (curr.totalIva ?? 0),
          })),
        },
      ]
    },
    refetchOnWindowFocus: true,
  })

  const [showModals, setshowModals] = useState<{
    showConfirm: boolean
    showAsiento: boolean
    data: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps | null
  }>({
    showConfirm: false,
    showAsiento: false,
    data: null,
  })

  const hideShowModals = () => {
    setshowModals({
      showConfirm: false,
      showAsiento: false,
      data: null,
    })
  }

  const createAsientoLiquidacionButton = async (
    record: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps | null
  ) => {
    try {
      if (!record || !record.periodo) return
      setIsLoadingConfirm(record.periodo)
      const asientoId: string = await postAsientoDeLiquidacion({
        anyo: parseInt(year.selectedYear, 10),
        periodo: record.periodo,
      })
      setshowModals({
        showConfirm: false,
        showAsiento: true,
        data: {
          ...showModals.data,
          asientoContableLiquidacionId: asientoId,
        },
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error al crear el asiento de liquidación:", error)
    } finally {
      setIsLoadingConfirm(false)
      refetch()
    }
  }

  const onSuccessDowloadFile = (
    response: AxiosResponse,
    headers: Record<string, string>
  ) => {
    const nameFile = extractFilename(headers["content-disposition"])
    handleDirectDownloadExcel(response, nameFile)
  }
  const requestHandleDownloadXml = async (periodo?: TrimestreEnumType) => {
    let notificationInfoId: string | undefined
    try {
      notificationInfoId = notification.info({
        body: t("notification.exporting"),
        duration: Infinity,
        icon: faSpinnerThird,
        isIconSpin: true,
      })
      const data = await MODELOS_IMPUESTOS()[
        isModel390 ? MODELO_IMPUESTO.MODELO_390 : MODELO_IMPUESTO.MODELO_303
      ].serviceExportResumenDetalle({
        Anyo: year.selectedYear,
        ...(periodo ? { Periodo: periodo } : {}),
        SortingCriteria: "DESC asientoContable.numero",
      })
      onSuccessDowloadFile(data, data.headers)
      if (data.status === STATUSCORRECT) {
        notificationInfoId && notification.dismiss(notificationInfoId)
        notification.success({
          body: `${t("taxSummary.detail.msg.downloadSuccess")}`,
        })
      }
    } catch (error) {
      notificationInfoId && notification.dismiss(notificationInfoId)
      notification.errorServidor({
        body: `${t("taxSummary.detail.msg.downloadError")}`,
      })
    }
  }
  const goToDeclaracionModelo = (
    rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
  ) => {
    history.push(isModel390 ? DECLARACION_MODELO_390 : DECLARACION_MODELO_303, {
      periodo: rowData.periodo,
      year: year.selectedYear,
    })
  }

  return (
    <>
      <div className='tw-py-4'>
        <div className='tw-rounded-t-xl tw-flex tw-bg-simple-10 tw-justify-between tw-items-center '>
          <p
            className={`tw-py-5 tw-pl-6 tw-m-0 ${
              isModel390 ? "tw-text-base" : "tw-text-lg tw-font-medium"
            }`}
          >
            {isModel390 ? (
              <Trans
                i18nKey='taxSummary.tableTitle390'
                className=''
                components={[
                  <span
                    className='tw-font-medium tw-contents !tw-text-lg !tw-m-0'
                    key='0'
                  />,
                ]}
              />
            ) : (
              t("taxSummary.tableTitle")
            )}
          </p>
          <Dropdown
            id='rangosFechaIvaImpuesto'
            name='rangosFechaivaImpuesto'
            className='tw-rounded-md tw-mr-6'
            value={year.selectedYear}
            options={yearsOptionList}
            onChange={handleYearSelection}
          />
        </div>
        <TableERP
          columns={IVA_IMPUESTOS_COLUMNS(
            t,
            navigate,
            year.selectedYear,
            setshowModals,
            isModel390,
            isLoadingConfirm,
            requestHandleDownloadXml,
            goToDeclaracionModelo
          )}
          className={
            isModel390 ? "tw-h-full tw-min-h-40" : "tw-h-full tw-min-h-80"
          }
          columnResizeMode='expand'
          value={data}
          showGridlines
          dataKey='id'
          lazy
          scrollable
          size='small'
          loading={isLoading}
        />
      </div>
      <ModalAsientoContable
        idToEdit={showModals.data?.asientoContableLiquidacionId ?? undefined}
        show={showModals.showAsiento}
        setShow={(bool: boolean) =>
          setshowModals((prev) => ({
            ...prev,
            showAsiento: bool,
          }))
        }
        updateTable={() => {
          refetch()
        }}
      />

      <Modal
        visible={showModals.showConfirm}
        onHide={() => hideShowModals()}
        size='small'
        closable={false}
        header={
          <div className='tw-w-full tw-flex tw-flex-col tw-items-center'>
            <div className='tw-w-60 tw-flex tw-justify-center !tw-p-0 tw-mb-4'>
              <span className='tw-w-24 tw-h-24 tw-flex tw-flex-col tw-justify-center tw-items-center tw-rounded-full tw-bg-background'>
                <div className='tw-w-16 tw-h-16 !tw-p-0 tw-flex tw-justify-center tw-items-center tw-bg-simple-10 tw-rounded-full tw-border tw-border-primary-10'>
                  <FontAwesomeIcon
                    icon={["fal", "question"]}
                    className='tw-text-info-100 tw-w-5 tw-h-8'
                  />
                </div>
              </span>
            </div>{" "}
            <div className='tw-w-60 tw-flex tw-flex-col !tw-p-0'>
              <span className='tw-text-center tw-w-full tw-text-lg tw-font-medium tw-mb-3'>
                {t("taxSummary.modal.title")}
              </span>
              <span className='tw-text-center tw-w-full tw-text-base tw-font-normal'>
                {t("taxSummary.modal.text")}{" "}
                <span className='tw-text-center tw-w-full tw-text-base tw-font-medium '>
                  {obtenerFechaFinTrimestre(
                    showModals.data?.periodo ?? null,
                    year.selectedYear
                  )}
                </span>
              </span>
            </div>
          </div>
        }
        className='!tw-w-80	tw-bg-simple-10 tw-rounded-lg'
      >
        <div className='tw-flex tw-flex-col tw-items-center tw-gap-1'>
          <ButtonERP
            customize={{
              size: "md",
              type: "primary",
            }}
            className='!tw-w-full'
            onClick={() => createAsientoLiquidacionButton(showModals.data)}
            label={`${t("taxSummary.modal.confirmLabel")}`}
          />
          <ButtonERP
            customize={{
              size: "md",
              type: "white",
            }}
            className='!tw-w-full'
            onClick={hideShowModals}
            label={`${t("taxSummary.modal.cancelLabel")}`}
          />
        </div>
      </Modal>
    </>
  )
}

export default ResumenImpuestos
